function startsWith(string, search) {
  if (search.length === 0) {
    return true;
  }
  if (search.length === 1) {
    return string[0] === search;
  }
  return string.substring(0, search.length) === search;
}
export {
  startsWith
};
//# sourceMappingURL=startsWith.js.map
